<template>
  <b-container class=""  v-if="getEnedisCaseOnGoing()">
    <h1>Affaire N°{{ getEnedisCaseOnGoing().oasiceNumber }}</h1>
    <div id="oasiceHeader">
      <OasiceNumberInputType id="oasiceForm" />
      <DeleteConfirmButton
              message="Supprimer l'affaire"
              title="Supprimer l'affaire"
              @confirmed="archivedEnedisCase()"
              v-if="isAdmin() || isAgent()"/>
    </div>
      <EnedisCaseType :tab-index-prop="tabIndex"/>

      <b-modal id="gapsModal" title="Détails des aléas" ok-only centered>
        <b-table :fields="fieldsGaps" :items="modalGaps">
          <template slot="type" slot-scope="row">
            {{ getGapType(row.item.type) }}
          </template>
        </b-table>
      </b-modal>
  </b-container>
  <div class="enedis-case-number-input-container" v-else-if="!getEnedisCaseOnGoing() && enedisCaseId === null">
    <OasiceEditCreateInputType @enedisCaseRecovered="setEnedisCase($event)"/>
  </div>
</template>

<script>
  import { EventBus } from '../../../event-bus.js';
  import { mapActions, mapGetters } from 'vuex';
  import Clone from 'clone';

  export default {
    name: 'EnedisCase',
    data() {
      return {
        enedisCaseId: null,
        tabIndex: null,
        fieldsGaps: [
          { key: 'code', label: 'Code' },
          { key: 'type', label: 'Type' },
          { key: 'description', label: 'Description' },
        ],
        modalGaps: [],
      };
    },
    watch: {
      enedisCaseOnGoing(newValue) {
        if (newValue === null) {
          this.enedisCaseId = null;
        }
      },
    },
    computed: {
      ...mapGetters({
        enedisCaseOnGoing: 'getEnedisCaseOnGoing',
      }),
    },
    methods: {
      ...mapActions([
      ]),
      ...mapGetters([
        'getEnedisCaseOnGoing',
        'isAdmin',
        'isAgent',
      ]),
      setEnedisCase(enedisCase) {
        if (enedisCase !== null) {
          const oasiceNumberEncoded = encodeURIComponent(enedisCase.oasiceNumber);
          const enedisCaseId = encodeURIComponent(enedisCase.id);
          this.$router.push(`/enediscase/${enedisCaseId}`);
        }
        this.$store.commit('setEnedisCaseOnGoing', enedisCase);
        if (enedisCase === null) {
          this.enedisCaseId = null;
          this.$router.push('/enediscase');
        }
      },
      archivedEnedisCase() {
        let formData = {
          archived: true,
        };

        axios.patch(`enedis-cases/${this.getEnedisCaseOnGoing().id}`, formData)
            .then((response) => {
              // Show success toast
              const toast = {
                show: true,
                message: 'Affaire supprimée avec succès !',
                variant: 'success',
                duration: 3000,
              };
              this.$store.commit('setGlobalToaster', toast);
              this.$router.push({ name: 'dashboard' });
            })
            .catch((error) => {
              // Show error toast
              const toast = {
                show: true,
                message: `Erreur lors de la suppression de l'affaire : ${error}`,
                variant: 'danger',
                duration: 3000,
              };
              this.$store.commit('setGlobalToaster', toast);
              console.error(error.message);
            });
      },
      getGapType(type) {
        switch (type) {
          case 1:
            return 'Réactivité';
            break;

          case 2:
            return 'Incomplétude';
            break;

          case 3:
            return 'Irrecevabilité';
            break;

          default:
            return 'Non précisé';
            break;
        }
      },
    },
    beforeCreate() {
      this.$store.dispatch('getUsers').finally();
    },
    beforeMount() {
      if (typeof this.$store.state.route.params.enedisCaseId !== 'undefined' && this.$store.state.route.params.enedisCaseId !== null) {
        // Set the id for title and place holding
        this.enedisCaseId = this.$store.state.route.params.enedisCaseId;
        // Handling the encoding of the oasice number since it appears in url
        let uri = this.$store.state.route.params.enedisCaseId;
        try {
          uri = decodeURIComponent(uri);
        } catch (e) {
          // console.warn(e);
          uri = encodeURIComponent(uri);
        }
        // If route contains query params, set params and replace route url
        if (typeof this.$store.state.route.query.tabIndex !== 'undefined' && this.$store.state.route.query.tabIndex !== null) {
          this.tabIndex = parseInt(this.$store.state.route.query.tabIndex);
          this.$router.replace(`/enediscase/${uri}`);
        }
        // Request
        this.$store.commit('setGlobalSpinnerShow', true);
        this.$store.dispatch('createGet', { id: this.enedisCaseId })
          .then((response) => {
            const toast = {
              show: true,
              message: `Affaire ${response.status === 201 ? 'créée' : 'récupérée'} avec succès !`,
              variant: 'success',
              duration: 3000,
            };
            // console.log('enedis case data : ', response.data);
            this.$store.commit('setGlobalToaster', toast);
            this.$store.commit('setEnedisCaseOnGoing', response.data);
          }, (error) => {
            if (error.status === 404) {
              if (typeof error.body.archived !== 'undefined') {
                // Show info error toast
                const toast = {
                  show: true,
                  message: `${error.body.message}`,
                  variant: 'info',
                  duration: 1500,
                };
                this.setEnedisCase(null);
                this.$store.commit('setGlobalToaster', toast);
              }
            }
          }).finally(() => {
            this.$store.commit('setGlobalSpinnerShow', false);
          });
      } else {
        this.setEnedisCase(null);
      }
      this.$store.dispatch('getCaseManagers').finally();
    },
    mounted() {
      // console.log('tabindex enedis case : ', this.tabIndex);
      if (typeof this.$route.params.sliceId != 'undefined') {
        this.tabIndex = parseInt(this.$route.params.sliceId);
      } else {
        this.tabIndex = null;
      }

      EventBus.$on('openGapsModal', gaps => {
        this.modalGaps = gaps;
        this.$bvModal.show('gapsModal');
      });
    },
    destroyed() {
      this.$store.commit('setEnedisCaseOnGoing', null);
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#oasiceForm {
  width: 540px;
}

  .enedis-case-number-input-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
  }

#oasiceHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/enedis-case/EnedisCase.vue